// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3xWoH","errorLogs":"EditorFooter_errorLogs__370au"};